import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_PreviewCardList } from '../PreviewCardList/PreviewCardList';
import { UI_PreviewCardProps } from 'ui/components/2-molecules/Card/PreviewCard/PreviewCard';
import ColorOptions from 'helpers/types';
import classNames from 'classnames';
import styles from './AdaptableList.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_TopLevelGrid } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGrid';
import { UI_TopLevelGridCell } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGridCell';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';

export interface UI_AdaptableListProps {
	adaptableListitem: UI_PreviewCardProps[];
	buttonText: string;
	title?: string;
	description?: string;
	bgColor?: ColorOptions;
}

export const UI_AdaptableList: React.FC<UI_AdaptableListProps> = ({ adaptableListitem, buttonText, bgColor, title, description }) => {
	return (
		<div className={classNames(styles.AdaptableList, styles[`u-color___${bgColor}`])}>
			<UI_Container width="Standard">
				{title && (
					<UI_Heading headingLevel="h2" style="xl" className={styles.AdaptableList_heading}>
						{title}
					</UI_Heading>
				)}
				<UI_TopLevelGrid nogutter wrap>
					<UI_TopLevelGridCell desktopWidth="10col" mobileWidth="100">
						{description && <UI_RichText content={description} className={styles.AdaptableList_description} />}
					</UI_TopLevelGridCell>
				</UI_TopLevelGrid>
				{adaptableListitem && (
					<UI_PreviewCardList
						items={adaptableListitem.map((item) => {
							return {
								...item,
								headline: item.headline,
								text: item.text,
								image: { ...item.image, altText: item.image.altText },
								link: item.link,
								tags: { first: item.tags.first, second: item.tags.second },
								video: {
									...item.video,
									mediaURL: item.video?.mediaURL,
									posterURL: item.image?.url,
								},
							};
						})}
						buttonText={buttonText}
						marginBottom
					/>
				)}
			</UI_Container>
		</div>
	);
};
